/** Reload the page so product APIs return post-sale catalog pricing. */
export function refreshFlashSalePricing() {
  if (typeof window !== 'undefined') {
    window.location.reload()
  }
}
